<template>
  <div>
    <v-stepper
      v-model="step"
      non-linear>
      <v-stepper-header>
        <v-stepper-step
          :complete="stepComplete[0]"
          :editable = "true"
          edit-icon="$vuetify.icons.complete"
          step="1"
        >
          <small>{{ strings[idioma].envia_info }}</small>
        </v-stepper-step>

        <v-divider/>

        <v-stepper-step
          :complete="stepComplete[1]"
          :editable = "stepComplete[0]"
          edit-icon="$vuetify.icons.complete"
          step="2"
        >
          <small>{{ strings[idioma].identificacao_alimento }}</small>
        </v-stepper-step>
        <v-divider/>
        <v-stepper-step
          :complete="stepComplete[2]"
          :editable = "stepComplete[1]"
          edit-icon="$vuetify.icons.complete"
          step="3"
        >
          <small>{{ strings[idioma].composicoes_alimento }}</small>
        </v-stepper-step>
      </v-stepper-header>
      <v-stepper-items style="margin-top: 3px">
        <v-stepper-content
          :style="heightOverflow"
          step="1">
          <v-card
            v-if="parseInt(step) === 1 && loadingAlimentos"
            class="mb-3"
          >
            <v-layout
              v-if="loadingAlimentos"
              :style="{'height': heightCard}"
              column
              fill-height
              justify-center
              align-center
            >
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              />
            </v-layout>
          </v-card>
          <template v-else>
            <div v-if="escolha">
              <v-layout
                row
                wrap
                justify-end
              >
                <v-flex
                  v-if="alimentosUsuario && alimentosUsuario.length > 0"
                  :xs12="alimentosUsuario">
                  <material-card
                    :text="strings[idioma].alimentos_usuario"

                    color="indigo lighten-5 font-weight-bold">
                    <v-list
                      dense
                      flat
                      rounded>

                      <v-list-tile
                        v-for="us in alimentosUsuario.filter(a => a.EXCLUIDO === 0)"
                        :key="us.id"
                        :style="us.EXCLUIDO === 1 ? 'opacity: 0.6;': null"
                        flat
                        @click="(remove) ? removeAlimento(us) : openAlimento(us)">
                        <v-list-tile-avatar>
                          <v-icon

                            v-text="'mdi-nutrition'"
                          />
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title>{{ us.nome }} - <i>{{ us.nome_cientifico }}</i> ({{ (us.publico) ? strings[idioma].livre_acesso_empresa: strings[idioma].privado }})</v-list-tile-title>
                          <v-list-tile-sub-title>{{ categorias_alimentos.filter(c=>c.id === us.id_tipo)[0][(idioma === 0 ? 'name' : (idioma === 1 ? 'name_en' : 'name_es'))] }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-btn
                            flat
                            color="error"
                            small
                            @click="remove = true"> X </v-btn>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </material-card>

                </v-flex>
                <p>{{ strings[idioma].cqbal_info_legal }}</p>

                <v-btn
                  v-if="empresa && empresa[0].acesso === 0"
                  color="primary"
                  @click="enviarEmpresa()"
                >
                  {{ strings[idioma].enviar_para_empresa }}
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn
                  v-if="acesso_premium"
                  color="primary"
                  @click="stepComplete[0] = true; basePessoal = true; resetAlimento(); step = 2;"
                >
                  {{ strings[idioma].enviar_base_pessoal }}
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn
                  color="primary"
                  @click="escolha = false; resetAlimento();step = 1;"
                >
                  {{ strings[idioma].enviar_cqbal }}
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-layout>
            </div>
            <div v-else>
              <div>
                <div
                  v-if="idioma === 0"
                  aria-labelledby="ui-id-1"
                  class="ui-tabs-panel ui-widget-content ui-corner-bottom"
                  role="tabpanel"
                  aria-expanded="true"
                  aria-hidden="false"><p>Prezado usuário,</p>
                  <p>Prezado, ao nos enviar a análise do seu alimento na opção enviar ao CQBAL, este comporá a média das análises que compõem o banco de dados do CQBAL, garantindo o sigilo de seus dados individuais.</p>
                  <p>Se quiser utilizar um alimento ou fonte de minerais que não faz parte de nosso banco de dados, você poderá enviar a composição deste utilizando o formulario na aba 'Dados do Alimento', incluindo obrigatoriamente, no caso de ingredientes de concentrados ou volumosos:</p>
                  <ul>
                    <li>MS (matéria seca)</li>
                    <li>
                      Pelo menos um:
                      <ul>
                        <li>MO (matéria orgânica) ou</li>
                        <li>MM (matéria mineral)</li>
                      </ul>
                    </li>
                    <li>EE (extrato etéreo)</li>
                    <li>PB (proteína bruta)</li>
                    <li>Lignina</li>
                    <li>
                      Pelo menos um:
                      <ul>
                        <li>FDN (fibra em detergente neutro) ou</li>
                        <li>FDNcp (fibra em detergente neutro corrigida para cinzas e proteína)</li>
                      </ul>
                    </li>
                    <li>
                      Pelo menos um:
                      <ul>
                        <li>CNF (carboidratos não fibrosos) ou</li>
                        <li>CNFcp (carboidratos não fibrosos corrigido para cinzas e proteína)</li>
                        <li>Obs: se não tiver o dado de CNF ou CNFcp mas tiver (MO ou MM, EE, PB, FDN ou FDNcp) ok pois será possível calcular o CNF.</li>
                      </ul>
                    </li>
                    <li>Pelo menos um dos seguintes grupos de dados:
                      <ul>
                        <li>PBA (fração solúvel da proteína bruta) e</li>
                        <li>PBB (fração potencialmente degradável da proteína bruta) e</li>
                        <li>PBkd (taxa de degradação da fração B)</li>
                      </ul>
                      ou, para uma kp=5%/h:
                      <ul>
                        <li>PDR (proteína degradada no rúmen) e</li>
                        <li>PNDR (proteína não degradada no rúmen)</li>
                      </ul>
                    </li>
                    <li>Pelo menos um dos seguintes grupos de dados:
                      <ul>
                        <li>PIDN/MS (proteína insolúvel em detergente neutro na base da matéria seca) e</li>
                        <li>PIDA/MS (proteína insolúvel em detergente ácido na base da matéria seca)</li>
                      </ul>
                      ou
                      <ul>
                        <li>PIDN/PB (proteína insolúvel em detergente neutro na base da proteína bruta) e</li>
                        <li>PIDA/PB (proteína insolúvel em detergente neutro na base da proteína bruta)</li>
                      </ul>
                      ou
                      <ul>
                        <li>NIDN/N (nitrogênio insolúvel em detergente neutro na base do nitrogênio total) e</li>
                        <li>NIDA/N (nitrogênio insolúvel em detergente ácido base do nitrogênio total)</li>
                      </ul>
                      ou
                      <ul>
                        <li>NIDN/MS (nitrogênio insolúvel em detergente neutro na base da matéria seca)</li>
                        <li>NIDA/MS (nitrogênio insolúvel em detergente ácido na base da matéria seca)</li>
                      </ul>
                    </li>
                  </ul>
                  <p>Obs: Se o alimento não possuir alguma fração necessária para o cálculo do NDT, usando as equações descritas no BR CORTE (2010), o usuário poderá acrescentar o NDT observado nos dados experimentais (necessário comprovação do valor).</p>
                  <p>
                    OBS - O usuário deverá encaminhar comprovante desses resultados, que pode ser via registro no MAPA, ou enviar o laudo de análise do alimento de um laboratório de Instituições públicas ( Universidades, Institutos de Pesquisa, EMBRAPA, etc...).<br>
                    Além disso, somente poderá ser cadastrado alimentos que não constem da tabela CQBAL resumida.
                  </p>
                  <p>Se for um premix, núcleo mineral, sal mineral, etc., o usuário deverá apresentar a composição dos macro (Ca, P, Mg, K, Na), expressa em g/kg  e dos microminerais (Co, Cu, I, Mn, Se, Zn), expressos em mg/kg ou ppm.</p>
                  <p>Ressaltamos que o usuário fará apenas um pré-cadastro e a composição do seu alimento será avaliada por nosso administrador. Em caso de aprovação, essa será acrescentada ao nosso banco de dados.</p>
                </div>
                <div
                  v-if="idioma === 1"
                  aria-labelledby="ui-id-1"
                  class="ui-tabs-panel ui-widget-content ui-corner-bottom"
                  role="tabpanel"
                  aria-expanded="true"
                  aria-hidden="false"><p>Dear User,</p>
                  <p>If you want to use a feed or mineral source that is not part of our database, you can send using the tab 'Data from feed', including mandatory in the case of concentrated or bulky ingredients:</p>
                  <ul>
                    <li>DM (dry matter)</li>
                    <li>
                      At least one of:
                      <ul>
                        <li>OM (organic matter) or</li>
                        <li>MM (ash)</li>
                      </ul>
                    </li>
                    <li>EE (ether extract)</li>
                    <li>CP (crude protein)</li>
                    <li>Lignin</li>
                    <li>
                      At least one of:
                      <ul>
                        <li>NDF (neutral detergent fiber) or</li>
                        <li>NDF (neutral detergent fiber corrected for ash and protein)</li>
                      </ul>
                    </li>
                    <li>
                      At least one of:
                      <ul>
                        <li>NFC (non-fiber carbohydrates) or</li>
                        <li>CNFCP (non-fiber carbohydrates corrected for ash and protein)</li>
                        <li>Note: if you have no CNF or CNFCP  data but you have (MO or MM, EE, CP, NDF or NDFcp) then  it will be possible to calculate the CNF.</li>
                      </ul>
                    </li>
                    <li>
                      At least one of the following groups of data:
                      <ul>
                        <li>PBA (soluble fraction of crude protein) and</li>
                        <li>PBB (potentially degradable fraction of crude protein) and</li><li/><li>PBkd (degradation rate of fraction B)</li>
                      </ul>
                      or, for a = 5% kp / h:
                      <ul>
                        <li>RDP (rumen degradable protein) and</li>
                        <li>RUP (rumen undegraded protein)</li>
                      </ul>
                    </li>
                    <li>
                      At least one of the following groups of data:
                      <ul>
                        <li>NIDP / DM (neutral detergent insoluble protein on dry matter basis) and</li>
                        <li>AIDP / DM (acid detergent insoluble protein on dry matter basis)</li>
                      </ul>
                      or
                      <ul>
                        <li>NIDP / CP (neutral detergent insoluble protein on the basis of crude protein) and</li>
                        <li>AIDP / CP(neutral detergent insoluble protein on the basis of crude protein)</li>
                      </ul>
                      or
                      <ul>
                        <li>NDIN / N (neutral detergent insoluble nitrogen on the basis of total nitrogen) and</li>
                        <li>ADIN / N (acid detergent insoluble nitrogen basis of total nitrogen)</li>
                      </ul>
                      or
                      <ul>
                        <li>NDIN / DM (neutral detergent insoluble nitrogen in dry matter basis)</li>
                        <li>ADIN / DM (acid detergent insoluble nitrogen in dry matter basis)</li>
                      </ul>
                    </li>
                  </ul>
                  <p>Note: If the feed does not have some fraction required for the calculation of TDN, using the equations described in BR CORTE (2010), the user can add the TDN observed in experimental data (need to send a proof of value).</p>
                  <p>
                    NOTE - The user must submit proof of these results. That can be by registration at MAPA, or sending the certificate of analysis of feed of some public institution laboratory (Universities, Research Institutes, etc.).<br>
                    Also, it can only be registered feed not available on the summarized table (CQBAL).
                  </p>
                  <p>If it is a premix mineral, a mineral source for ration formulation, other mineral sources, the user must submit the composition of macro (Ca, P, Mg, K, Na), expressed in g / kg and trace minerals (Co, Cu, I, Mn , Se, Zn), expressed in mg / kg or ppm.</p>
                  <p>We emphasize that the user will only complete a pre-registration and the composition of its feed will be evaluated by our administrator. If approved, its composition will be added to our database.</p>
                </div>
              </div>
              <v-layout
                row
                wrap
                justify-end
              >
                <v-btn
                  color="primary"
                  @click="stepComplete[0] = true; step = 2;"
                >
                  {{ strings[idioma].botao_seguinte }}
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-layout>
            </div>
          </template>
        </v-stepper-content>
        <v-stepper-content
          :style="heightOverflow"
          step="2">
          <div :style="heightOverflow">
            <div v-if="etapaAlimentoBase">
              <h3>Deseja Criar um Alimento Baseado em algum desses alimentos?</h3>
              <v-layout
                row
                wrap
                justify-end
              >

                <v-flex pb-2>
                  <v-treeview
                    ref="dTreeAlimentos"
                    :style="heightTree"
                    :items="categorias_alimentos"
                    :search="search"
                    :filter="filter"
                    :item-text="idioma === 0 ? 'name' : (idioma === 1 ? 'name_en' : 'name_es')"
                    :active.sync="alimentoClick"
                    :open.sync="open"
                    v-model="treeAlimentos"
                    :open-all="expandeArvore"
                    :selectable="true"
                    item-children="derivados"
                    class="grey lighten-5"
                    active-class = ""
                    selected-color="primary"
                    activatable
                    transition
                    expand-icon="mdi-chevron-down"
                    on-icon="mdi-checkbox-marked"
                    off-icon="mdi-checkbox-blank-outline"
                    indeterminate-icon="mdi-minus-box"
                    return-object
                  >
                    <template
                      slot="label"
                      slot-scope= "{ item }">
                      <span
                        v-if="item.derivados"
                        style="cursor: pointer; font-weight: 600; text-decoration-color: grey;"
                        @click="open = (open[0] !== item) ? [item] : []"> {{ item[idioma === 0 ? 'name' : (idioma === 1) ? 'name_en' : 'name_es'] }} </span>
                      <span
                        v-else
                        style="cursor: pointer;"> {{ item[idioma === 0 ? 'name' : (idioma === 1) ? 'name_en' : 'name_es'] }} <v-icon
                          v-if="item.patrocinado"
                          :title="strings[idioma].recomendado_brcorte"
                          color="primary">mdi-star</v-icon> <v-icon
                            v-if="item.patrocinado"
                            :title="strings[idioma].recomendado_brcorte"
                            color="primary"
                            @click="info = true; verEmpresa(item);">mdi-information</v-icon> </span>
                    </template>
                  </v-treeview>
                  <v-layout
                    v-if="fontesMineraisSelecionada"
                    justify-start
                    wrap
                  >
                    <v-flex pb-2>
                      <v-btn
                        block
                        color="primary"
                        @click="checkMineraisComuns">{{ (!getSelecionaComunsStatus) ? strings[idioma].selecionar_fontes_mais_comuns: strings[idioma].deselecionar_fontes_mais_comuns }}</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout
                row
                wrap
                justify-end
              >
                <v-btn
                  color="primary"
                  @click="stepComplete[1] = true; etapaAlimentoBase = false"
                >
                  {{ strings[idioma].nao_quero }}
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-layout>
            </div>
            <v-list v-if="step==2 && !etapaAlimentoBase">
              <div>
                <div class="title">{{ strings[idioma].identificacao_alimento }}</div>
                <template>
                  <v-list-tile
                    class="list-restricoes">
                    <v-list-tile-content>
                      <v-layout
                        align-center
                        justify-space-around
                        row
                        py-2
                        style="width: 100%"
                      >
                        <v-flex
                          xs7
                          sm8
                          md5>
                          <span style="font-weight: 500;"> {{ strings[idioma].nome_alimento }}: </span>
                        </v-flex>
                        <v-flex
                          xs5
                          sm4
                          md7>
                          <v-text-field
                            v-model="alimento.nome"
                            outline
                            class="text-field-table text-field-nutrientes"
                            color="primary"
                          />
                        </v-flex>
                      </v-layout>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider/>
                  <v-list-tile
                    class="list-restricoes">
                    <v-list-tile-content>
                      <v-layout
                        align-center
                        justify-space-around
                        row
                        py-2
                        style="width: 100%"
                      >
                        <v-flex
                          xs7
                          sm8
                          md5>
                          <span style="font-weight: 500;"> {{ strings[idioma].nome_cientifico }}: </span>
                        </v-flex>
                        <v-flex
                          xs5
                          sm4
                          md7>
                          <v-text-field
                            v-model="alimento.nome_sci"
                            outline
                            class="text-field-table text-field-nutrientes"
                            color="primary"
                          />
                        </v-flex>
                      </v-layout>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider/>
                  <v-list-tile
                    class="list-restricoes">
                    <v-list-tile-content>
                      <v-layout
                        align-center
                        justify-space-around
                        row
                        py-2
                        style="width: 100%"
                      >
                        <v-flex
                          xs7
                          sm8
                          md5>
                          <span style="font-weight: 500;"> {{ strings[idioma].tipo_alimento }}: </span>
                        </v-flex>
                        <v-flex
                          xs5
                          sm4
                          md7>
                          <v-select
                            key="id"
                            v-model="alimento.tipo"
                            v-bind="binding"
                            :items="categorias_alimentos"
                            :item-text="item => idioma === 0 ? item.name : idioma === 1 ? item.name_en : item.name_es"
                            item-value="id"
                            class="text-field-table"
                            dense

                          />
                        </v-flex>
                      </v-layout>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider/>
                </template>
              </div>
            </v-list>
          </div>
          <v-layout
            row
            wrap
            justify-end
          >
            <v-btn
              color="primary"
              @click="stepComplete[1] = true; step = 3;"
            >
              {{ strings[idioma].botao_seguinte }}
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-layout>
        </v-stepper-content>
        <v-stepper-content
          :style="heightOverflow"
          step="3">
          <div>
            <v-list v-if="step==3">
              <div class="title">{{ strings[idioma].informacoes_nutricionais }}</div>
              <template
                v-for="(ingrediente, index) in ingredientes"
              >
                <v-list-tile
                  :key="index"
                  class="list-restricoes">
                  <v-list-tile-content>
                    <v-layout
                      align-center
                      justify-space-around
                      row
                      py-2
                      style="width: 100%"
                    >
                      <v-flex
                        xs7
                        sm8
                        md9>
                        <span style="font-weight: 500;"> {{ !idioma ? ingrediente.exigencia : ingrediente.exigencia_en }} </span>
                      </v-flex>
                      <v-flex
                        xs5
                        sm4
                        md3>
                        <v-text-field
                          v-model="alimento.nutrientes[ingrediente.id]"
                          :suffix="!idioma ? ingrediente.unidade : ingrediente.unidade_en"
                          :value="alimento.nutrientes[ingrediente.id]? alimento.nutrientes[ingrediente.id] : '0.00'"
                          outline
                          class="text-field-table text-field-nutrientes"
                          color="primary"
                          @change="val => changeIngrediente(ingrediente.id, val, ingrediente.unidade)"
                        />
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                </v-list-tile>

              </template>
            </v-list>
          </div>
          <v-layout
            row
            wrap
            justify-end
          >
            <v-btn
              color="primary"
              @click="envia()"
            >
              {{ strings[idioma].salvar }}
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-layout>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getAlimentosEmpresa } from '@/utils/utils'

export default {
  data: () => ({
    alimentoBase: null,
    etapaAlimentoBase: true,
    alimento: {
      nome: '',
      nome_sci: '',
      tipo: null,
      nutrientes: {},
      user: {}
    },
    step: 1,
    loadingAlimentos: false,
    escolha: false,
    basePessoal: false,
    stepComplete: [false, false],
    alimentosUsuario: [],
    alimentoClick: [],
    arrayTable: [
      {
        id: 'ok'
      }
    ],
    calculandoDieta: false,
    calculandoNutrientes: false,
    changeMinMax: false,
    dialogNutrientes: false,
    dietaOtimizada: false,
    dietaSemiOtima: false,
    editarExigencias: false,
    loadingStep2: false,
    indexAlimentoDialog: 0,
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    open: [],
    pagination: {
      rowsPerPage: 20,
      sortBy: null,
      descending: false,
      page: 1,
      totalItems: 0
    },
    recalculandoExigencias: false,
    search: null,
    searchRestricao: null,
    fixaVC: false,
    treeAlimentos: [],
    validAnimal: false,
    selected: false,
    indetermined: false,
    volumososSelecionados: [],
    concentradoSelecionados: [],
    selecionaComuns: false,
    expandeArvore: false,
    travaSelectAll: false,
    info: false
  }),
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user', 'ingredientes', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'empresa', 'acesso_premium']),

    binding () {
      const binding = {}
      if (this.$vuetify.breakpoint.mdAndUp) binding.row = true
      else binding.row = false
      return binding
    },
    selectable () {
      return this.open.length > 0
    },
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 289) + 'px'
    },
    heightOverflow () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 120) + 'px; overflow: auto;'
    }
  },
  watch: {
    'alimentoClick' (val) {
      this.alimentoBase = val
      console.log(this.alimentoBase)
    },
    'treeAlimentos' (val) {
      if (Math.abs(this.alimentos_selecionados.length - val.length) > 2) {
        this.treeAlimentos = this.alimentos_selecionados
        return
      }
      this.$store.commit('setAlimentosSelecionados', val)
      this.pagination.totalItems = this.alimentos_selecionados.length
      this.stepComplete[0] = val.length !== 0
    },
    'open' (val) {
      if ((this.search === '' || this.search === null) && val.length > 1) {
        this.open = [val[val.length - 1]]
      }
    }
  },
  created () {
    this.escolha = this.acesso_premium
    if (!this.$store.state.app.categorias_alimentos) {
      this.loadingAlimentos = true
      this.axios.post('alimentos/lastUpdateAt', {}).then(response => {
        let lastUpdate = parseInt(response.data.data[1])
        if (lastUpdate === parseInt(localStorage.getItem('lastUpdate'))) {
          let tipos = JSON.parse(localStorage.getItem('tipos'))
          let alimentos = JSON.parse(localStorage.getItem('alimentos'))
          this.$store.commit('setAlimentos', { tipos: tipos, alimentos: alimentos })
          this.loadingAlimentos = false
        } else {
          this.axios.post('tipos', {}).then(response => {
            let tipos = response.data.data
            localStorage.setItem('tipos', JSON.stringify(tipos))
            this.axios.post('relatorio/alimentosBrCorte', {}).then(response => {
              localStorage.setItem('alimentos', JSON.stringify(response.data.data))
              this.$store.commit('setAlimentos', { tipos: tipos, alimentos: response.data.data })
              this.loadingAlimentos = false
              localStorage.setItem('lastUpdate', lastUpdate)
            }).catch(error => {
              console.log(error)
            })
          })
        }
      })
    }
    let meusAlimentos = []
    this.axios.post('alimentos/getAlimentosUsuario', { id_pessoa: this.user.id }).then((res) => {
      for (let al of res.data.data) {
        let alim = Object.assign({}, al)
        alim['nutrientes'] = JSON.parse(al.nutrientes)
        meusAlimentos.push(alim)
      }
      this.alimentosUsuario = meusAlimentos
      this.$store.commit('setAlimentosUsuario', { alimentos: meusAlimentos })
    })
  },
  methods: {
    enviarEmpresa () {
      sessionStorage.removeItem('empresaAdm')
      sessionStorage.removeItem('alimentoCarregado')
      this.go('/empresa/add-alimento')
    },
    resetAlimento () {
      this.alimento = {
        nome: '',
        nome_sci: '',
        tipo: null,
        nutrientes: {},
        user: {}
      }
    },
    go (url) {
      window.location.href = url
    },
    openAlimento (al) {
      let alimento = Object.assign({}, al)
      alimento.nome_sci = alimento.nome_cientifico
      alimento.tipo = alimento.id_tipo
      for (let nut in alimento.nutrientes) {
        alimento.nutrientes[nut] = parseFloat(alimento.nutrientes[nut]).toFixed(2).replace('.', this.strings[this.idioma].separador_float)
      }
      this.alimento = alimento
      this.stepComplete[0] = true
      this.step = 2
      this.basePessoal = true
      sessionStorage.setItem('alimentoCarregado', JSON.stringify(alimento))
      // window.location.href = '/empresa/add-alimento'
    },
    removeAlimento (al) {
      delete this.remove
      if (confirm(this.strings[this.idioma].msg_remove)) {
        this.axios.post('alimentos/removeAlimento', { id: al.id }).then((res) => {
          let meusAlimentos = []
          this.axios.post('alimentos/getAlimentosUsuario', { id_pessoa: this.user.id }).then((res) => {
            for (let al of res.data.data) {
              let alim = Object.assign({}, al)
              alim['nutrientes'] = JSON.parse(al.nutrientes)
              meusAlimentos.push(alim)
            }
            this.alimentosUsuario = meusAlimentos
            // this.$store.commit('setAlimentosUsuario', { alimentos: meusAlimentos })
          })
        }).catch(() => alert('Erro, ao remover o alimento!!!'))
      }
    },
    changeIngrediente (ingrediente, nutriente, unidade) {
      let val = this.parseString(nutriente, this.idioma)
      this.alimento.nutrientes[ingrediente] = isNaN(this.alimento.nutrientes[ingrediente]) ? 0 : this.alimento.nutrientes[ingrediente]

      if (unidade === '%') {
        this.alimento.nutrientes[ingrediente] = (this.idioma === 0 || this.idioma === 2) ? (val > 100 ? 100 : (val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace(',', '').replace('.', ',') : (val > 100 ? 100 : (val < 0) ? 0 : val).toFixed(2).replace('.', ',')
      } else {
        this.alimento.nutrientes[ingrediente] = (this.idioma === 0 || this.idioma === 2) ? ((val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace(',', '').replace('.', ',') : ((val < 0 || isNaN(val)) ? 0 : val).toFixed(2).replace('.', ',')
      }
      return this.alimento.nutrientes[ingrediente]
    },
    parseString (valor, idioma) {
      if ((idioma === 0 || idioma === 2) && valor && valor !== '-') {
        if (valor[valor.length - 3] === '.') return parseFloat(valor)
        return parseFloat(valor.replace(/[.]/g, '').replace(/[,]/g, '.'))
      } else if (valor && valor !== '-') {
        return parseFloat(valor.replace(/[,]/g, ''))
      }
      return 0
    },
    enviaBasePessoal () {
      let assert = this.alimento.nome.length >= 3 && this.alimento.tipo !== null
      if (!assert) {
        let msg = this.strings[this.idioma].campos_faltantes + ((this.alimento.nome.length < 3) ? '\n O alimento deve ter no mínimo 3 caracteres!!!' : '')
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
        let title = '❌ ATENÇÃO'
        this.$store.commit('openOKModal', {
          title,
          msg,
          error: true
        })

        return
      }
      this.alimento.user = this.user
      this.alimento.id_pessoa = (this.alimento.id_pessoa) ? this.alimento.id_pessoa : this.user.id
      this.alimento.nome_ingles = this.alimento.nome_espanhol = this.alimento.nome
      this.alimento.nome_cientifico = this.alimento.nome_sci
      // this.alimento.id_empresa = this.empresa.id
      delete this.alimento.nome_sci
      delete this.alimento.nutrientes_raw
      this.alimento.id_tipo = this.alimento.tipo
      let nutrientes = Object.assign({}, this.alimento.nutrientes)
      for (let ingredienteID in this.ingredientes) {
        let ingrediente = this.ingredientes[ingredienteID]
        if (!nutrientes[ingrediente.id]) nutrientes[ingrediente.id] = '0'
        nutrientes[ingrediente.id] = parseFloat(String(nutrientes[ingrediente.id]).replace(this.strings[this.idioma].separador_float, '.'))
      }
      this.alimento.nutrientes = JSON.stringify(nutrientes)
      delete this.alimento.tipo
      delete this.alimento.user
      delete this.alimento.empresa
      this.axios.post('empresa/addAlimento', { alimento: this.alimento }).then((res) => {
        let msg = this.strings[this.idioma].cadastrado
        let title = ''
        this.$store.commit('openOKModal', { title, msg })
        window.location.go(0)
        console.log(res)
      }).catch((err) => {
        console.log(err)
      })
      console.log(this.alimento)
    },
    envia () {
      let assert = this.alimento.nome.length >= 3 && this.alimento.tipo !== null
      if (!assert) {
        let msg = this.strings[this.idioma].campos_faltantes + ((this.alimento.nome.length < 3) ? '\n O alimento deve ter no mínimo 3 caracteres!!!' : '')
        let time = 6000
        this.$store.commit('openErrorAlert', { msg, time })
        let title = '❌ ATENÇÃO'
        this.$store.commit('openOKModal', {
          title,
          msg,
          error: true
        })

        return
      }
      this.alimento.user = this.user
      localStorage.setItem('alimento', this.alimento)
      let alimento = this.alimento
      let user = this.user
      if (this.basePessoal) {
        return this.enviaBasePessoal()
      }
      this.axios.post('https://cqbal.com.br/api/brcorte/enviaAlimento', { 'alimento': alimento, 'user': user }).then(response => {
        console.log(response)
        let msg = this.strings[this.idioma].alimento_enviado
        let time = 6000
        this.$store.commit('openSuccessAlert', { msg, time })
        let title = '✔ Sucesso'
        this.$store.commit('openOKModal', {
          title,
          msg,
          error: false
        })
      })
      console.log(this.alimento)
    }
  }
}
</script>
